import type { AnyAction, Middleware } from 'redux';
import { USER_PROFILE_FETCH_SUCCESS } from '../../actions/actionTypes/userProfile';
import { isMainConnectionOpen } from '../../selectors/call';
import { getAuthToken } from '../../selectors/auth';
import { getProfileCompanyName, getProfileEmail, getProfileUserName } from '../../selectors/profile';
import { isUserLoaded } from '../../selectors/user';
import { startMainConnection, initListener, types as mainTypes } from '../../actions/backendMain';
import { dispatchBackend } from '../../types/backend';

const user: Middleware = store => {
    const { getState } = store;
    return next => (action: AnyAction) => {
        const nextAction = next(action);

        switch (action.type) {
            case USER_PROFILE_FETCH_SUCCESS: {
                if (!isMainConnectionOpen(getState())) {
                    dispatchBackend(store.dispatch, startMainConnection());
                } else {
                    dispatchBackend(store.dispatch, initListener());
                }

                // set user info to a global object (important for bridge protocol to electron app) # do not remove
                const state = getState();
                window.user = {
                    companyName: getProfileCompanyName(state),
                    userName: getProfileUserName(state) || getProfileEmail(state),
                    jwt: getAuthToken(state) ?? null
                };

                break;
            }
            case mainTypes.MAIN_CONNECTION_OPENED: {
                if (isUserLoaded(getState())) {
                    dispatchBackend(store.dispatch, initListener());
                }
                break;
            }
            default:
        }

        return nextAction;
    };
};

export default user;
